import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const LEGACY_CATEGORY = 'Data Location';

const LOCATION_COPY_EVENT_NAMES = {
  COPY_COORDINATE: 'map_copy_coordinate',
};

export const handleCopy = ({
  value,
  name,
  irpVersion,
  payloadID,
  requestID,
  onStart,
  onEnd,
  portalType,
}) => {
  navigator.clipboard.writeText(value);
  gspx.trackEvent({
    name: LOCATION_COPY_EVENT_NAMES.COPY_COORDINATE,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `Copy '${name}'`,
      Category: 'Location Card Copy coordinates',
      'Launched date': new Date(),
      irpVersion,
      portalType,
    },
    entities: {
      payload_id: payloadID,
      request_id: requestID,
    },
  });
  onStart();
  setTimeout(() => {
    onEnd();
  }, 3000);
};
